/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class NumberUtil {
    public static toBase64String(bytes: number[]): string {
        let binary = "";
        for (const byte of bytes) {
            binary += String.fromCharCode(byte);
        }

        return window.btoa(binary);
    }

    public static clamp(n: number, min: number, max: number): number {
        return Math.min(Math.max(n, min), max);
    }

    public static divmod(a: number, b: number): [number, number] {
        const remainder = a % b;
        const quotient = a - remainder;
        return [quotient, remainder];
    }

    public static sum(numbers: number[]) {
        return numbers.reduce((acc, n) => acc + n, 0);
    }
}
